import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useOrg } from '../contexts/OrgContext';

export default function AdminRoute() {
  const { isAdmin, loading } = useOrg();

  if (loading) return null;

  if (!isAdmin) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
